<template>
  <div class="card bg-light mb-3 border-0 p-10">
    <div class="card-body">
      <div class="card-title p-2">
        <div class="row align-items-center">
          <div class="col-10">
            <titles :text="data.participantTypeName"></titles>
          </div>
          <div class="col-2 text-right">
            <el-dropdown trigger="click" @command="handleCommand">
              <el-button type="text" class="custom-button" style="padding: 0 !important;">
                <div class="square-icon">
                  <i class="fas fa-ellipsis-h" style="color: #808080;"></i>
                </div>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{ action: 'edit', id: data.id }" @click.native="handleEdit(data.id)">
                  <span style="display: inline-flex; align-items: center; width: 100%;">
                    <i class="fa-solid fa-pen-to-square" style="width: 20px; text-align: center;"></i>
                    <span>{{$t('Düzəliş')}}</span>
                  </span>
                </el-dropdown-item>

                <el-dropdown-item
                  :disabled="(roles.includes('Accident commissar operator') && this.readonly) || (this.uid !== data.createUser)"
                  :command="{ action: 'delete', id: data.id }" @click.native="handleDelete(data.id)">
                  <span style="display: inline-flex; align-items: center; width: 100%;">
                    <i class="fa-solid fa-trash-can" style="width: 20px; text-align: center;"></i>
                    <span>{{$t('Sil')}}</span>
                  </span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <hr width="100%" size="50" style="margin-top: 5px; margin-bottom: 5px;height: 1px;background: #F3EFE0;" align="left">
        <div class="row">
          <div class="col-12">
            <div class="info-item">
              <span class="info-label" style="font-weight: bold; color: #3A3A3A">
                {{ data.damageType === 1 ? 'A.S.A.' 
                  : data.damageType === 2 ? 'Xəsarət alan' 
                  : 'Əmlak sahibi' }}:
              </span>
              <span class="info-value">
                {{ data.participantType === 1 ? data.personName : data.partPersonName }}
              </span>
            </div>
            
            <div class="info-item">
              <span class="info-label" style="font-weight: bold; color: #3A3A3A">
                {{$t('Sığorta_növü')}}:
              </span>
              <span class="info-value">{{ data.policyTypeName }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Upload from "./Upload.vue";
import {
  CopyParticipant,
  CheckPolicyStatus
} from "../../services/accident";
import { textLeft } from "../../services/helper";
import Titles from "./Titles.vue";

export default {
  components: {
    Titles
    // Upload,
  },
  props: {
    item: Object,
    readonly: { type: Boolean, default: false }
  },
  data() {
    return {
      data: this.item,
      uid: this.$store.state.user.id,
      roles: this.$store.state.user.roles,
      policyStatus:false,
      textLeft: textLeft,

    };
  },
  methods: {
    handleCommand(command) {
      let id = command.id;
      let accidentId = command.accidentId;
      let createUserId = command.createUserId;
      if (command.action === "edit") this.handleEdit(id);
      else if (command.action === "delete") this.handleDelete(id);
      else if (command.action === "report") this.handleReport(id, accidentId, createUserId);
      else if (command.action === "copy") this.handleCopy(id,accidentId);

    },
    handleEdit(id) {
      this.$emit("edit", id);
    },
    handleReport(id, accidentId, createUserId) {
      this.$emit("report", id, accidentId, createUserId, this.readonly);
    },
    checkPolicyStatus() {
      this.policyStatus = false;
      return new Promise((resolve, reject) => {
        CheckPolicyStatus(this.data.accidentId).then((response) => {
          if (response.data.data) {
            this.policyStatus = response.data.data;
          }
          resolve(this.response);
        }, error => {
        })
      })
    },
    handleCopy(id,accidentId) {
      CopyParticipant(id,accidentId,this.uid).then((response) => {
        this.loading = false;
        if (response.data.data) {
          if (!response.data.isSuccess) {
            this.$message({
              type: "error",
              message: response.data.errors[0],
            });
          } else {
            this.$message({
              type: "success",
              message: this.$t('Uğurlu_əməliyyat'),
            });
            this.$emit("refresh");
          }
        } else {
          this.$message({
            type: "error",
            message: this.$t('Səhv_əməliyyat'),
          });
        }
      });
    },
    handleDelete(id) {
      this.$emit("delete", id);
    },
  },
  watch: {
    item() {
      this.data = this.item;

    },
  },
  mounted() {
    this.checkPolicyStatus();

},
};
</script>

<style lang="scss" scoped></style>